import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { lt } from 'ember-truth-helpers';
import HotelStrategyEmptyMetricBlock from 'lumen/components/hotel/strategy/empty-metric-block';
import HotelStrategyTypeCard from 'lumen/components/hotel/strategy/type-card';

interface HotelStrategyPosTypeCardSignature {
  Args: {
    canEditPOS: unknown;
    data: unknown;
    isLoading: unknown;
    nbOfRowsInCard: unknown;
    redirectAction: unknown;
    switchToDetailViaPositionButton: unknown;
    switchToDetailViaTitleExpand: unknown;
  };
}

const HotelStrategyPosTypeCard = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <HotelStrategyTypeCard
    @data={{@data}}
    @isLoading={{@isLoading}}
    @nbOfRowsInCard={{@nbOfRowsInCard}}
    @switchToDetailViaPositionButton={{@switchToDetailViaPositionButton}}
    @switchToDetailViaTitleExpand={{@switchToDetailViaTitleExpand}}
  >
    {{#if (lt @data.filteredSubtypes.length 3)}}
      {{#if @canEditPOS}}
        <HotelStrategyEmptyMetricBlock
          @canRedirect={{true}}
          @iconName="plus"
          @label={{t "rate_strategy.add_pos"}}
          @redirectAction={{@redirectAction}}
        />
      {{else}}
        <HotelStrategyEmptyMetricBlock
          @canRedirect={{false}}
          @iconName="circle-information-outline"
          @label={{t "rate_strategy.add_pos.readonly"}}
          @redirectAction={{@redirectAction}}
        />
      {{/if}}
    {{/if}}
  </HotelStrategyTypeCard>
</template> satisfies TOC<HotelStrategyPosTypeCardSignature>;

export default HotelStrategyPosTypeCard;
